import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class HostService {
    private hostUrl: string = '';

    getHostRoot(): string {
        if(this.hostUrl === '' && environment.profile === 'prod') {
            this.hostUrl =  window.location.protocol + '//api-' + window.location.hostname;
        }
        return this.hostUrl;
    }
}
